import { getColorByShortcut } from '../../../../../utils/colors';

import {
  last,
  first,
  cloneDeep,
  upperFirst,
  join,
  some,
  reverse,
  lowerFirst,
} from 'lodash';
import {
  findMarkWords,
  getMarkWord,
  calculateTime,
  copyToClipboard,
  isLetterUpperCase,
  hasDot,
  hasPunctuation,
} from '../utils/functions';

// ***************************************************************************************
// On sélectionne les mots avec les touches clavier
// ***************************************************************************************

export function onSelect(key) {
  if (this.underSelection) {
    if (key === 'SELECTTOP') {
      if (selectCurrentIndex === 0) {
        return;
      }
    }

    if (key === 'SELECTBOTTOM') {
      if (selectCurrentIndex === last(this.script).index) {
        return;
      }
    }
  }

  if (key === 'SELECTLEFT' || key === 'SELECTRIGHT') {
    this.onSelectLeftOrRight(key);
  } else {
    this.onSelectTopOrBottom(key);
  }
}

let selectCurrentIndex = 0;
let selectStartIndex = 0;

export function onSelectLeftOrRight(key) {
  if (!this.underSelection || !this.wordsToSelect.length) {
    if (!this.currentWord.text) {
      return;
    }

    this.underSelection = true;
    this.wordsToSelect = [];
    this.lettersToSelect = [];

    this.wordsToSelect.push(this.currentWord);

    selectStartIndex = this.currentWord.index;
    selectCurrentIndex = this.currentWord.index;

    this.onRefreshCanvas(false);

    return;
  }

  if (selectCurrentIndex === selectStartIndex) {
    const firstWord = first(this.wordsToSelect);
    const lastWord = last(this.wordsToSelect);

    if (firstWord.index === selectCurrentIndex) {
      selectCurrentIndex = lastWord.index;
    } else {
      selectCurrentIndex = firstWord.index;
    }
  }

  let shouldRemove = false;
  if (key === 'SELECTLEFT') {
    shouldRemove = selectCurrentIndex > selectStartIndex;
  } else {
    shouldRemove = selectCurrentIndex < selectStartIndex;
  }

  if (shouldRemove) {
    if (key === 'SELECTLEFT') {
      this.wordsToSelect.pop();
    } else {
      this.wordsToSelect.shift();
    }

    if (!this.wordsToSelect.length) {
      this.underSelection = false;
      return;
    }

    if (selectStartIndex < selectCurrentIndex) {
      const lastWord = last(this.wordsToSelect);
      selectCurrentIndex = lastWord.index;
      this.scrollToUp(lastWord);
    } else {
      const firstWord = first(this.wordsToSelect);
      selectCurrentIndex = firstWord.index;
      this.scrollToDown(firstWord);
    }

    return;
  }

  if (key === 'SELECTLEFT') {
    selectCurrentIndex--;
  } else {
    selectCurrentIndex++;
  }

  const word = this.script[selectCurrentIndex];
  if (!word || word.submitted) {
    return;
  }

  if (key === 'SELECTLEFT') {
    this.wordsToSelect.unshift(word);
    this.scrollToUp(word);
  } else {
    this.wordsToSelect.push(word);
    this.scrollToDown(word);
  }

  selectCurrentIndex = word.index;
}

export function onSelectTopOrBottom(key) {
  if (!this.underSelection) {
    this.underSelection = true;
    this.wordsToSelect = [];
    this.lettersToSelect = [];
  }

  if (!this.wordsToSelect.length) {
    const startIndex = this.currentWord.index;
    let startLineIndex = this.currentWord.indexLine;
    let endLineIndex = this.currentWord.indexLine;

    this.wordsToSelect = getWordsToSelect(
      this.script,
      startIndex,
      startLineIndex,
      endLineIndex,
      key === 'SELECTDOWN'
    );

    if (key === 'SELECTUP') {
      selectCurrentIndex = first(this.wordsToSelect).index;
    } else {
      selectCurrentIndex = last(this.wordsToSelect).index;
    }

    selectStartIndex = startIndex;
    this.onRefreshCanvas(false);

    return;
  }

  const startWord = first(this.wordsToSelect);
  const endWord = last(this.wordsToSelect);

  // on déselectionne le premier mot du texte
  if (this.currentWord.index === 0 && startWord.index === endWord.index) {
    this.underSelection = false;
    this.wordsToSelect = [];
    this.onRefreshCanvas(false);
    return;
  }

  if (key === 'SELECTUP') {
    const prevWord = this.script[startWord.index - 1];
    if (!prevWord || prevWord.submitted) {
      return;
    }

    this.wordsToSelect = handleSelectUp(
      this.script,
      this.currentWord,
      startWord,
      endWord
    );

    this.scrollToUp(prevWord);
  } else {
    const nextWord = this.script[endWord.index + 1];
    if (!nextWord) {
      return;
    }

    this.wordsToSelect = handleSelectDown(
      this.script,
      this.currentWord,
      startWord,
      endWord
    );

    this.scrollToDown(nextWord);
  }

  if (selectStartIndex < selectCurrentIndex) {
    selectCurrentIndex = last(this.wordsToSelect).index;
  } else {
    selectCurrentIndex = first(this.wordsToSelect).index;
  }
}

function handleSelectUp(script, currentWord, startWord, endWord) {
  const startIndex = currentWord.index;
  const firstIndex = startWord ? startWord.index : startIndex;
  const lastIndex = endWord ? endWord.index : startIndex;

  let startLineIndex = startWord ? startWord.indexLine : currentWord.indexLine;
  let endLineIndex = endWord ? endWord.indexLine : currentWord.indexLine;

  if (startLineIndex < endLineIndex && startIndex < lastIndex) {
    endLineIndex -= 1;
    return getWordsToSelect(
      script,
      startIndex,
      startLineIndex,
      endLineIndex,
      true
    );
  } else {
    if (firstIndex <= startIndex) {
      startLineIndex -= 1;
    }

    return getWordsToSelect(
      script,
      startIndex,
      startLineIndex,
      endLineIndex,
      false
    );
  }
}

function handleSelectDown(script, currentWord, startWord, endWord) {
  const startIndex = currentWord.index;
  const firstIndex = startWord ? startWord.index : startIndex;
  const lastIndex = endWord ? endWord.index : startIndex;

  let startLineIndex = startWord ? startWord.indexLine : currentWord.indexLine;
  let endLineIndex = endWord ? endWord.indexLine : currentWord.indexLine;

  if (startIndex === firstIndex && startIndex < lastIndex) {
    endLineIndex += 1;
    return getWordsToSelect(
      script,
      startIndex,
      startLineIndex,
      endLineIndex,
      true
    );
  }

  if (firstIndex < startIndex) {
    if (startLineIndex === endLineIndex) {
      return getWordsToSelect(
        script,
        startIndex,
        startLineIndex,
        endLineIndex,
        true
      );
    }

    startLineIndex += 1;
    return getWordsToSelect(
      script,
      startIndex,
      startLineIndex,
      endLineIndex,
      false
    );
  } else {
    endLineIndex += 1;
    return getWordsToSelect(
      script,
      startIndex,
      startLineIndex,
      endLineIndex,
      true
    );
  }
}

function getWordsToSelect(
  script,
  startIndex,
  startLineIndex,
  endLineIndex,
  isGreaterThanEqual
) {
  return script.filter(
    (x) =>
      !x.submitted &&
      (isGreaterThanEqual ? x.index >= startIndex : x.index <= startIndex) &&
      startLineIndex <= x.indexLine &&
      x.indexLine <= endLineIndex
  );
}

// ***************************************************************************************
// onBackspace supprime un caractère en arrière
// ***************************************************************************************
export function onBackspace() {
  // On supprime les mots sélectionnées en cas de sélection en cours
  if (this.underSelection) {
    if (this.lettersToSelect.length) {
      this.removeLettersInSelection(this.lettersToSelect, 'onBackspace', () =>
        this.onBackspace()
      );
      return;
    }

    this.removeWordsInSelection(this.wordsToSelect, 'onBackspace', () =>
      this.onBackspace()
    );
    return;
  }

  if (
    this.currentWordIndex === 0 &&
    this.currentLineIndex === 0 &&
    this.currentLetterIndex === 0
  ) {
    return;
  }

  // Si le mot précédent a été validé, on ne fait rien
  if (!this.currentWord.letters.length) {
    const prevWord = this.script[this.currentWordIndex - 1];
    if (prevWord && prevWord.submitted) {
      return;
    }
  }

  const currentIndex = this.currentWord.letters.findIndex(
    (l) => l.indexLetter === this.currentLetterIndex
  );

  // Si le caractère précédent est un espace alors on supprime l'espace et on attache deux mots en un mot
  if (currentIndex === 0) {
    this.addNewActionForUndo('onBackspace', this.currentWordIndex - 1, 1, 0);

    const prevWord = this.script[this.currentWordIndex - 1];
    if (prevWord.submitted) {
      this.currentWord.newline = false;
      this.forceRecalculateLines = true;
      this.takeFirstLetter = true;
    } else {
      prevWord.text += this.currentWord.text;
      prevWord.endTime = this.currentWord.endTime;

      this.script.splice(this.currentWord.index, 1);

      this.currentWordIndex--;
      this.currentLetterIndex--;
    }

    if (this.currentWord.indexLine !== prevWord.indexLine) {
      // on va prendre voir si le dernier mot va aller à la ligne
      if (prevWord.endX + this.currentWord.width > this.width - this.metricX) {
        this.currentLetterIndex = prevWord.letters.length - 1;
        this.forceRecalculateLines = true;
      }
    }

    if (this.currentLetterIndex === -1) {
      this.currentLetterIndex = last(prevWord.letters).indexLetter;
      this.currentLineIndex--;
      this.forceRecalculateLines = true;
    }

    this.onChange(this.currentWord.startTime, this.currentWord.index);

    return;
  }

  this.addNewActionForUndo('onBackspace', this.currentWordIndex);

  const currentText = this.currentWord.text;

  // on efface un caractère si la longueur du texte est supérieure à 1 sachant que le dernier caractère est un espace
  if (currentText.length > 1) {
    this.currentWord.text =
      currentText.substring(0, currentIndex - 1) +
      currentText.substring(currentIndex);
  } else {
    if (currentText.length === 1) {
      const prevWord = this.script[this.currentWordIndex - 1];

      // Si le mot précédent a été validé, on ne supprime pas le mot vide
      if (prevWord && prevWord.submitted) {
        this.currentWord.text = '';
        this.onChange(this.currentWord.startTime, this.currentWord.index);
        return;
      }

      // On supprime le mot
      this.script.splice(this.currentWord.index, 1);

      // on change de position
      if (prevWord) {
        prevWord.endTime = this.currentWord.endTime;
        this.setPositionForCursor(prevWord, false);
      }

      if (this.currentWord.index === 0) {
        this.currentLineIndex = 0;
        this.currentWordIndex = 0;
        this.currentLetterIndex = 0;
      }

      this.onChange(this.currentWord.startTime, this.currentWord.index);

      return;
    }
    // S'il ne reste plus de caractère, on supprime le mot
    const nextWord = this.script[this.currentWordIndex + 1];
    if (nextWord) {
      nextWord.startTime = this.currentWord.endTime;
      this.script.splice(this.currentWord.index, 1);
    }

    this.currentWordIndex--;
  }
  this.currentLetterIndex--;

  // si la dernière lettre du mot est un point alors on remet la lettre suivante au minuscule
  const lastLetter = currentText[currentText.length - 1]
  if (lastLetter === '.' || lastLetter === "?" || lastLetter == "!") {
    const nextWord = this.script[this.currentWordIndex + 1];
    if (nextWord && isLetterUpperCase(nextWord.text[0])) {
      nextWord.text = lowerFirst(nextWord.text);
    }
  }
  else {
    const prevLetter = currentText[this.currentLetter.index - 1];
    if (prevLetter === '.' || prevLetter === "?" || prevLetter == "!") {
      this.currentWord.text =
        this.currentWord.text.substring(0, this.currentLetter.index - 1) +
        this.currentLetter.letter.toLowerCase() +
        this.currentWord.text.substring(this.currentLetter.index);
    }
  }
  

  this.onChange(this.currentWord.startTime, this.currentWord.index);
}

// ***************************************************************************************
// onBackspaceLeftToRight supprime un caractère devant pour les mots en arabe / hébreu
// ***************************************************************************************
export function onBackspaceLeftToRight() {
  // On supprime les mots sélectionnées en cas de sélection en cours
  if (this.underSelection) {
    if (this.lettersToSelect.length) {
      this.removeLettersInSelection(
        this.lettersToSelect,
        'onBackspaceLeftToRight',
        () => this.onBackspaceLeftToRight()
      );
      return;
    }

    this.removeWordsInSelection(
      this.wordsToSelect,
      'onBackspaceLeftToRight',
      () => this.onBackspaceLeftToRight()
    );
    return;
  }

  // s'il en reste un, on supprime
  if (this.script.length === 1) {
    this.addNewActionForUndo('onBackspace', this.currentWordIndex);
    this.script.splice(this.currentWord.index, 1);
    this.currentLetterIndex = 0;
    this.onChange(this.currentWord.startTime, this.currentWord.index);
    return;
  }

  // Si le mot courant a été validé, on ne fait rien
  if (this.currentWord.submitted) {
    return;
  }

  const word = this.currentWord;

  let textUpdated = '';
  let i = 0;
  for (const ch of reverse(Array.from(word.text))) {
    if (i === this.currentLetter.index) {
      i++;
      continue;
    }

    textUpdated = ch + textUpdated;
    i++;
  }

  word.text = textUpdated;

  // on supprime le mot
  if (!word.text.length) {
    const nextWord = this.script[word.index + 1];

    this.script.splice(word.index, 1);

    this.currentLineIndex = nextWord.indexLine;
    this.currentWordIndex = nextWord ? nextWord.index - 1 : 0;
    this.currentLetterIndex =
      nextWord && nextWord.letters.length
        ? first(nextWord.letters).indexLetter
        : 0;
  }

  this.onChange(this.currentWord.startTime, this.currentWord.index);
}

// ***************************************************************************************
// onEnter via la touche Entrée permet d'aller à la ligne
// ***************************************************************************************
export function onEnter() {
  // On supprime les mots sélectionnées en cas de sélection en cours
  if (this.underSelection) {
    if (this.lettersToSelect.length) {
      this.removeLettersInSelection(this.lettersToSelect, 'OnEnter', () =>
        this.onEnter()
      );
      return;
    }

    this.removeWordsInSelection(this.wordsToSelect, 'OnEnter', () =>
      this.onEnter()
    );
    return;
  }

  const { startTime, endTime, index, text, letters, newline } =
    this.currentWord;

  // Si on est au début de la ligne, alors on créé une nouvelle ligne
  if (this.currentLetterIndex === 0) {
    // le mot courant est déjà un mot vide, on ne créé pas de nouvelles lignes vides
    if (text === '') {
      return;
    }

    this.addNewActionForUndo('onEnter', index, 0, 1);

    const prevWord = this.script[index - 1];

    const newWord = {
      ...this.currentWord,
      text: '',
      newline: true,
      startTime: prevWord ? prevWord.endTime : 0,
      endTime: startTime,
      letters: [],
      markWord: false,
      cpbefore: false,
      cpafter: false,
      cpinside: false,
    };

    this.script.splice(index, 0, newWord);

    // hack pour la première ligne du texte qui n'est pas en newline
    if (!newline) {
      this.currentWord.newline = true;
    }

    this.hasEmptyWord = true;
    this.forceRecalculateLines = true;

    this.onChange(startTime, index);
    return;
  }

  // si le mot est vide
  if (!letters.length) {
    const nextWord = this.script[index + 1];
    if (!nextWord) {
      this.currentWord.newline = true;

      this.forceRecalculateLines = true;
      this.onChange(startTime, index);
      return;
    }

    // si le prochain mot est déjà la ligne suivante alors le mot vide va à la ligne
    if (nextWord.newline) {
      // on historise l'action
      this.addNewActionForUndo('onEnter', this.currentWord.index, 0, 0);
      this.currentWord.newline = true;
    } else {
      // on supprime l'action précédente
      this.undoActions.pop();

      // on historise l'action ici parce que l'index aura changé
      const undo = {
        currentWordIndex: this.currentWordIndex - 1,
        currentLineIndex: this.currentLineIndex,
        currentLetterIndex: this.currentLetterIndex,
        scrollOffsetLine: this.scrollOffsetLine,
        startIndex: nextWord.index - 1,
        nbToUndo: 0,
        nbToRedo: 0,
        words: cloneDeep([nextWord]),
        actionType: 'onEnter',
      };

      this.undoActions.push(undo);

      // on supprime le mot vide et le mot suivant va à la ligne parce qu'on ne veut pas laisser d'espace vide
      this.script.splice(index, 1);
      nextWord.newline = true;
    }

    this.currentLetterIndex = 0;
    this.currentLineIndex++;

    this.forceRecalculateLines = true;
    this.onChange(startTime, index);

    return;
  }

  const currentIndex = this.currentWord.letters.findIndex(
    (l) => l.indexLetter === this.currentLetterIndex
  );

  if (currentIndex === -1) {
    return;
  }

  // couper le mot en deux et le mot suivant va à la ligne
  const textWord1 = text.substring(0, currentIndex);
  const textWord2 = text.substring(currentIndex);

  // Si c'est le dernier caractère
  const lastLetter = last(letters);
  const isLastChar = currentIndex === lastLetter.index && lastLetter.lastChar;

  // Si le mot suivant n'est pas vide ou si c'est le dernier caractère de la phrase,
  // alors on créé un nouveau mot qui va à la ligne
  if ((textWord1 !== '' && textWord2 !== '') || isLastChar) {
    // on historise l'action
    this.addNewActionForUndo('onEnter', index, 0, 1);

    const inOutTime = calculateTime(startTime, endTime, text, textWord1);

    this.currentWord.text = textWord1;
    this.currentWord.endTime = inOutTime;

    const newWord = {
      ...this.currentWord,
      text: textWord2,
      newline: true,
      startTime: inOutTime,
      endTime: endTime,
      letters: [],
      markWord: false,
      cpbefore: false,
      cpafter: false,
      cpinside: false,
    };

    this.script.splice(this.currentWordIndex + 1, 0, newWord);

    if (textWord2 === '') {
      this.hasEmptyWord = true;
    }

    this.currentWordIndex++;
  } else {
    // sinon le prochain mot va à la ligne
    // on historise l'action
    this.addNewActionForUndo('onEnter', index);

    if (textWord1 === '') {
      this.currentWord.newline = true;
    } else {
      const nextWord = this.script[this.currentWordIndex + 1];
      nextWord.newline = true;

      this.currentWordIndex++;
    }
  }

  if (this.currentWord.endY + this.lineHeight > this.height) {
    this.scrollToDown(this.currentWord, true);
  }

  this.currentLetterIndex = 0;
  this.currentLineIndex++;
  this.forceRecalculateLines = true;

  this.onChange(startTime, index);
}

// ***************************************************************************************
// onDelete permet de supprimer un caractère devant
// ***************************************************************************************
export function onDelete() {
  // On supprime les mots sélectionnées en cas de sélection en cours
  if (this.underSelection) {
    if (this.lettersToSelect.length) {
      this.removeLettersInSelection(this.lettersToSelect, 'OnDelete', () =>
        this.onDelete()
      );
      return;
    }
    this.removeWordsInSelection(this.wordsToSelect, 'OnDelete', () =>
      this.onDelete()
    );
    return;
  }

  //Si c'est le dernier caractère du texte, ne rien faire
  const lastLine = this.script[this.script.length - 1].indexLine;
  if (this.currentLineIndex === lastLine && this.currentLetter.lastChar) {
    return;
  }

  const currentIndex = this.currentLetter.index;

  // coller deux mots en un (et donc supprimer l'espace)
  if (
    !this.currentWord.letters.length ||
    currentIndex === this.currentWord.letters.length - 1
  ) {
    const nextWord = this.script[this.currentWordIndex + 1];
    if (!nextWord) {
      return;
    }

    // Historiser l'action
    this.addNewActionForUndo('onDelete', this.currentWord.index, 1, 0);

    this.currentWord.text += nextWord.text;
    this.currentWord.endTime = nextWord.endTime;

    if (this.currentWord.indexLine !== nextWord.indexLine) {
      this.forceRecalculateLines = true;

      // Calculer si ça va à la ligne, si oui, on repositionne le curseur à la ligne
      if (this.currentWord.endX + nextWord.endX >= this.width) {
        this.currentLetterIndex = this.currentWord.letters.length - 1;
      }
    }

    this.script.splice(nextWord.index, 1);
    this.onChange(this.currentWord.startTime, this.currentWord.index);

    return;
  }

  if (this.currentWord.text.length === 1) {
    // Historiser l'action
    this.addNewActionForUndo('onDelete', this.currentWord.index, 1, 0);

    // On supprime le mot
    this.script.splice(this.currentWord.index, 1);

    if (this.script.length) {
      // on change de timecode
      const nextWord = this.script[this.currentWord.index];
      if (nextWord) {
        nextWord.startTime = this.currentWord.startTime;

        this.currentLineIndex = nextWord.indexLine;
        this.currentWordIndex = nextWord.index - 1;

        if (nextWord.newline) {
          this.currentLetterIndex = 0;
        }
      } else {
        const prevWord = this.script[this.currentWord.index - 1];

        if (prevWord) {
          prevWord.endTime = this.currentWord.endTime;
          this.currentLineIndex = prevWord.indexLine;
          this.currentWordIndex = prevWord.index;
        }
      }
    }

    this.onChange(this.currentWord.startTime, this.currentWord.index);
    return;
  }

  // Historiser l'action
  this.addNewActionForUndo('onDelete', this.currentWord.index);

  // Supprimer le caractère devant
  const currentText = this.currentWord.text;

  this.currentWord.text =
    currentText.substring(0, currentIndex) +
    currentText.substring(currentIndex + 1);

  this.onChange(this.currentWord.startTime, this.currentWord.index);
}

// ***************************************************************************************
// onDeleteLeftToRight permet de supprimer un caractère en arrière pour les mots en arabe / hébreu
// ***************************************************************************************
export function onDeleteLeftToRight() {
  // On supprime les mots sélectionnées en cas de sélection en cours
  if (this.underSelection) {
    if (this.lettersToSelect.length) {
      this.removeLettersInSelection(
        this.lettersToSelect,
        'onDeleteLeftToRight',
        () => this.onDeleteLeftToRight()
      );
    }

    this.removeWordsInSelection(this.wordsToSelect, 'onDeleteLeftToRight', () =>
      this.onDeleteLeftToRight()
    );
    return;
  }

  if (
    this.currentWordIndex === 0 &&
    this.currentLineIndex === 0 &&
    this.currentLetterIndex === 0
  ) {
    return;
  }

  if (this.currentWord.submitted) {
    return;
  }

  const word = this.currentWord;

  let indexToDelete = this.currentLetter.index - 1;
  if (indexToDelete === -1) {
    indexToDelete = 0;
  }
  let textUpdated = '';
  let i = 0;

  for (const ch of reverse(Array.from(word.text))) {
    if (i === indexToDelete) {
      i++;
      continue;
    }

    textUpdated = ch + textUpdated;
    i++;
  }

  word.text = textUpdated;

  // on supprime le mot
  if (!word.text.length) {
    const prevWord = this.script[word.index - 1];

    this.script.splice(word.index, 1);

    this.currentLineIndex = prevWord.indexLine;
    this.currentWordIndex = prevWord ? prevWord.index : 0;
    this.currentLetterIndex =
      prevWord && prevWord.letters.length
        ? last(prevWord.letters).indexLetter
        : 0;
  }

  this.onChange(this.currentWord.startTime, this.currentWord.index);
}

// ***************************************************************************************
// onDeleteWord permet de supprimer un mot
// ***************************************************************************************
export function onDeleteWord() {
  if (
    this.currentWordIndex === 0 ||
    (this.currentWord.newline &&
      this.currentWordIndex !== this.script.length - 1)
  ) {
    // Historiser l'action
    this.addNewActionForUndo('onDeleteWord', this.currentWord.index, 2, 1);

    const nextWord = this.script[this.currentWordIndex + 1];
    nextWord.newline = this.currentWord.newline;
    nextWord.startTime = this.currentWord.startTime;
  } else {
    // Historiser l'action
    this.addNewActionForUndo('onDeleteWord', this.currentWord.index - 1, 2, 1);

    const prevWord = this.script[this.currentWordIndex - 1];
    prevWord.endTime = this.currentWord.endTime;
  }

  this.script.splice(this.currentWordIndex, 1);

  if (some(this.currentWord.letters, (x) => x.lastChar === true)) {
    this.currentWordIndex--;
  }

  this.onChange(this.currentWord.startTime, this.currentWord.index);
}

// ***************************************************************************************
// onDeleteLine permet de supprimer la ligne
// ***************************************************************************************
export function onDeleteLine() {
  const indexLine =
    this.currentWord.parentIndexLine ?? this.currentWord.indexLine;

  const words = this.getWordsByIndexLine(indexLine);
  const firstWord = first(words);
  const lastWord = last(words);

  if (this.currentWordIndex === this.script.length - 1) {
    // Historiser l'action
    this.addNewActionForUndo(
      'onDeleteLine',
      firstWord.index - 1,
      words.length + 1,
      0
    );

    // on met à jour le timecode
    const prevWord = this.script[lastWord.index - 1];
    if (prevWord) {
      prevWord.endTime = lastWord.endTime;
    }
  } else {
    // Historiser l'action
    this.addNewActionForUndo('onDeleteLine', firstWord.index, words.length, 0);

    // on met à jour le timecode
    const nextWord = this.script[lastWord.index + 1];
    nextWord.startTime = firstWord.startTime;
  }

  // On supprime la ligne
  this.script.splice(firstWord.index, words.length);

  // On affecte la nouvelle position du curseur
  if (this.currentWordIndex >= this.script.length) {
    const lastWord = last(this.script);
    this.currentLineIndex = lastWord.indexLine;
    this.currentWordIndex = lastWord.index;
  } else {
    this.currentWordIndex = firstWord.index;
    this.takeFirstLetter = true;
  }

  this.onChange(this.currentWord.startTime, this.currentWord.index);
}

// ***************************************************************************************
// onMoveWordByWord permet de tabuler mot à mot que ce soit en avant ou en arrière
// ***************************************************************************************
export function onMoveWordByWord(back) {
  let word;

  if (back) {
    if (this.currentWordIndex === 0) {
      return;
    }

    word = this.script[this.currentWordIndex - 1];
  } else {
    if (this.currentWordIndex === this.script.length - 1) {
      return;
    }

    word = this.script[this.currentWordIndex + 1];
  }

  if (!word.letters) {
    const line = this.script.filter((elt) => elt.indexLine === word.indexLine);

    this.addLettersToNewLine(line);
  }

  this.currentLetterIndex = word.letters[0].indexLetter;
  this.currentLineIndex = word.indexLine;
  this.currentWordIndex = word.index;

  if (back) {
    // scroll vers le haut
    this.scrollToUp(word);
  } else {
    // scroll vers le bas
    this.scrollToDown(word);
  }

  this.onMove();
}

// ***************************************************************************************
// On copie colle
// ***************************************************************************************

export function onCopy() {
  if (this.wordsToSelect.length) {
    this.wordsSelected = [...this.wordsToSelect];

    // Copier dans le presse-papiers
    copyToClipboard(this.wordsSelected);
  }

  if (this.lettersToSelect.length) {
    const stringToCopy = join(
      this.lettersToSelect.map((x) => x.letter),
      ''
    );

    // Copier dans le presse-papiers
    navigator.clipboard.writeText(stringToCopy).then(
      () => {
        console.log('presse-papiers modifié avec succès');
      },
      () => console.log("échec de l'écriture dans le presse-papiers")
    );
  }
}

export function onPaste() {
  if (this.wordsSelected.length) {
    this.pasteWords(this.wordsSelected, false);
  } else {
    // Si le mot vient d'ailleurs
    navigator.clipboard.readText().then((clipText) => {
      this.pasteWords(clipText.split(' '), true);
    });
  }
}

// ***************************************************************************************
// On coupe
// ***************************************************************************************
export function onCut() {
  if (this.wordsToSelect.length) {
    this.wordsSelected = [...this.wordsToSelect];

    this.removeWordsInSelection(this.wordsSelected, 'OnCut', () =>
      this.onCut()
    );

    // Copier dans le presse-papiers
    copyToClipboard(this.wordsSelected);
  }

  if (this.lettersToSelect.length) {
    // TODO
  }
}

// ***************************************************************************************
// onMarkWord permet de marquer un mot
// ***************************************************************************************
export function onMarkWord(key) {
  // On historise
  this.addNewActionForUndo('onMarkWord', this.currentWord.index);

  const markWord = getMarkWord(key);

  const keys = findMarkWords(this.currentWord.markWord);

  if (keys.includes(markWord)) {
    this.currentWord.markWord -= markWord.value;
  } else {
    this.currentWord.markWord += markWord.value;
  }

  this.onChange(this.currentWord.startTime, this.currentWord.index);
  this.onRefreshCanvas();
}

// ***************************************************************************************
// onSetColor applique la couleur à partir du mot en cours jusqu'à la fin de la phrase ou toute la phrase
// ou applique la couleur sur la sélection
// ***************************************************************************************
export function onSetColor(key) {
  const color = getColorByShortcut(key);

  if (!color) {
    return;
  }

  // Appliquer la couleur dans la sélection
  if (this.underSelection) {
    if (this.lettersToSelect.length) {
      return;
    }

    const firstWord = first(this.wordsToSelect);

    // Historiser l'action
    this.addNewActionOnUnderSelectionForUndo(
      'onSetColor',
      firstWord.index,
      this.wordsToSelect,
      () => this.onSetColor(key)
    );

    this.wordsToSelect.forEach((word) => {
      word.color = color.hex;
    });

    this.onChange(firstWord.startTime, firstWord.index);

    return;
  }

  const indexLine =
    this.currentWord.parentIndexLine ?? this.currentWord.indexLine;

  const words = this.getWordsByIndexLine(indexLine);

  const wordsColored = words.filter((x) => x.color === color.hex);
  if (words.length === wordsColored.length) {
    return;
  }

  // Historiser l'action
  this.addNewActionForUndo(
    'onSetColor',
    first(words).index,
    words.length,
    words.length
  );

  const allColor = words
    .filter((w) => w.index >= this.currentWord.index)
    .every((x) => x.color === color.hex);

  words.forEach((word) => {
    // on applique la couleur sur toute la phrase
    if (allColor) {
      word.color = color.hex;
    } else {
      // On applique la couleur à partir du mot en cours jusqu'à la fin de la phrase
      if (word.index >= this.currentWord.index) {
        word.color = color.hex;
      }
    }
  });

  this.onChange(this.currentWord.startTime, this.currentWord.index);
}

// ***************************************************************************************
// onSelectWithCtrlA
// Première fois, sélectionne le mot, deuxième fois, la phrase, troisième fois tout le texte.
// ***************************************************************************************
let nbCtrlA = 0;
export function onSelectWithCtrlA() {
  if (!this.underSelection || nbCtrlA === 3) {
    this.underSelection = true;
    this.wordsToSelect = [];
    nbCtrlA = 0;
  }

  nbCtrlA++;

  if (nbCtrlA === 1) {
    this.wordsToSelect.push(this.currentWord);
  } else {
    if (nbCtrlA === 2) {
      const words = this.script.filter(
        (x) =>
          x.index > this.currentWord.index &&
          (x.indexLine === this.currentWord.indexLine ||
            x.parentIndexLine === this.currentWord.indexLine)
      );

      this.wordsToSelect.push(...words);
    } else {
      this.wordsToSelect = this.script;
    }
  }

  this.onRefreshCanvas(false);
}

// ***************************************************************************************
// onSelectSentence permet de sélectionner jusqu'au début ou jusqu'à la fin de la phrase
// ***************************************************************************************
export function onSelectSentence(key) {
  if (!this.underSelection) {
    this.underSelection = true;
    this.wordsToSelect = [];
  }

  const indexLine =
    this.currentWord.parentIndexLine ?? this.currentWord.indexLine;

  if (key === 'SELECTUPSENTENCE') {
    this.wordsToSelect = this.script.filter(
      (x) =>
        x.index <= this.currentWord.index &&
        (x.indexLine === indexLine || x.parentIndexLine === indexLine)
    );

    const firstWord = first(this.wordsToSelect);
    if (firstWord.indexLine !== this.currentLineIndex) {
      this.scrollToUp(firstWord);
      return;
    }
  } else {
    this.wordsToSelect = this.script.filter(
      (x) =>
        x.index >= this.currentWord.index &&
        (x.indexLine === indexLine || x.parentIndexLine === indexLine)
    );

    const lastWord = last(this.wordsToSelect);
    if (lastWord.indexLine !== this.currentLineIndex) {
      this.scrollToDown(lastWord);
      return;
    }
  }

  this.onRefreshCanvas(false);
}

// ***************************************************************************************
// onTab permet de corriger le mot quand on fait l'action Tab
// ***************************************************************************************
export function onTab() {
  if (!this.commonErrors) {
    return;
  }

  let originalText;
  let currentText;

  const regex = /[!?.,;:()\\[\]\\]/g;

  if (this.underSelection) {
    originalText = join(
      this.wordsToSelect.map((x) => x.text),
      ' '
    );

    currentText = originalText.replace(regex, '');
  } else {
    originalText = this.currentWord.text;
    currentText = this.currentWord.text.replace(regex, '');
  }

  const wordToChange = this.commonErrors.find((x) =>
    x.some((word) => word.toLowerCase() === currentText.toLowerCase())
  );

  if (wordToChange) {
    let index = wordToChange.findIndex(
      (x) => x.toLowerCase() === currentText.toLowerCase()
    );

    if (index === wordToChange.length - 1) {
      index = 0;
    } else {
      index++;
    }

    let newText = originalText.replace(
      currentText,
      isLetterUpperCase(currentText[0])
        ? upperFirst(wordToChange[index])
        : wordToChange[index]
    );

    if (this.underSelection) {
      const firstWord = first(this.wordsToSelect);
      const lastWord = last(this.wordsToSelect);

      if (firstWord.newline) {
        newText = upperFirst(newText);
      }

      const newWord = {
        ...firstWord,
        text: newText,
        startTime: firstWord.startTime,
        endTime: lastWord.endTime,
        letters: [],
      };

      this.replaceWords(firstWord.index, lastWord.index, [newWord]);
      this.underSelection = false;

      return;
    }

    if (this.currentWord.newline) {
      newText = upperFirst(newText);
    }

    this.currentWord.text = newText;

    // A reactiver : On lance la vérification des mots
    // this.onCheckLineByWord(this.currentWord);

    this.onChange(this.currentWord.startTime, this.currentWord.index);
  }
}

// ***************************************************************************************
// onChangeTranscription permet de switcher entre la transcription originale et la transcription corrigée
// ***************************************************************************************
export function onChangeTranscription() {


if (this.props.onSwapTranscription) 
  this.props.onSwapTranscription(this.state.transcription.hasDisplayOriginal);


  const {
    hasDisplayOriginal,
    original: originalTranscription,
    corrected: correctedTranscription,
  } = this.state.transcription;

  if (hasDisplayOriginal) {
    this.setState({
      transcription: {
        ...this.state.transcription,
        hasDisplayOriginal: false,
        id: correctedTranscription.id,
        description: correctedTranscription.description,
      },
    });

    

    this.script = cloneDeep(correctedTranscription.script);
    this.readonly = this.props.readonly;
  } else {
    if (originalTranscription.script === null) {
      this.setState({
        popup: {
          ...this.state.popup,
          display: true,
          showIcon: true,
          text: {
            fr: "La transcription originelle n'a pas été chargée ou n'a pas fini de charger. Veuillez réessayer.",
            en: 'The original transcript has not been loaded or has not finished loading. Please try again.',
          },
        },
      });

      return;
    }

    this.setState({
      search: {
        ...this.state.search,
        showReplace: false,
      },
      transcription: {
        ...this.state.transcription,
        id: originalTranscription.id,
        hasDisplayOriginal: true,
        description: originalTranscription.description,
        corrected: {
          ...this.state.transcription.corrected,
          script: cloneDeep(this.script),
        },
      },
    });

    this.script = cloneDeep(originalTranscription.script);
    this.readonly = true;
  }

  this.onCanvasChange(true);

  if (this.script.length) {
    const startTime = this.currentWord?.startTime;
    if (startTime) {
      this.goto(startTime);
    }
  }

  this.onRefreshCanvas();
}

// ***************************************************************************************
// onDeleteWordsUntil permet de supprimer les mots du début de la ligne jusqu'au mot courant
// ***************************************************************************************
export function onDeleteWordsUntil() {
  if (!this.currentWord || this.currentWord.index === 0) {
    return;
  }

  const wordsToDelete = this.script.filter(
    (x) =>
      x.index < this.currentWord.index &&
      (x.indexLine === this.currentWord.indexLine ||
        x.parentIndexLine === this.currentWord.indexLine)
  );

  if (!wordsToDelete.length) {
    return;
  }

  const firstWord = first(wordsToDelete);

  // On historise
  this.addNewActionForUndo(
    'onDeleteWordsUntil',
    firstWord.index,
    wordsToDelete.length + 1,
    1
  );

  this.currentWord.startTime = firstWord.startTime;
  this.currentWord.newline = true;
  this.currentWord.text = upperFirst(this.currentWord.text);

  this.script.splice(firstWord.index, wordsToDelete.length);

  this.currentWordIndex = firstWord.index;
  this.currentLetterIndex = 0;

  this.onChange(this.currentWord.index, this.currentWord.startTime);
  this.onCanvasChange(true);
}

// ***************************************************************************************
// onSubmitWord permet d'envoyer le mot validé en direct (et donc le mot devient unmodifiable)
// ***************************************************************************************
export function onSubmitWord() {
  const { index, startTime, endTime } = this.currentWord;

  this.currentWord.submitted = true;

  // on créé un nouveau mot
  if (index === this.script.length - 1) {
    const newWord = {
      ...this.currentWord,
      submitted: false,
      text: '',
      startTime: endTime,
      letters: [],
      markWord: false,
      cpbefore: false,
      cpafter: false,
      cpinside: false,
    };

    this.script.push(newWord);

    this.onCanvasChange(true);
  }

  const nextWord = this.script[index + 1];
  if (nextWord) {
    this.currentWordIndex = nextWord.index;
    this.currentLineIndex = nextWord.indexLine;

    this.takeFirstLetter = true;    

    this.scrollToDown(nextWord);
  }

  this.onChange(index, startTime);
}

// ***************************************************************************************
// onSubmitSentence permet d'envoyer la phrase jusqu'au point ou jusqu'à la prochaine ponctuation
// Les mots sont validés en direct (et donc ils deviennent unmodifiable)
// ***************************************************************************************
export function onSubmitSentence(punctuation) {
  const { index, startTime, indexLine } = this.currentWord;

  const indexOf = this.script.findIndex(
    (word) =>
      !word.submitted &&
      word.index >= index &&
      (punctuation ? hasPunctuation(word.text) : hasDot(word.text))
  );

  const wordsToSubmit = this.script.filter(
    (x) => !x.submitted && x.index <= indexOf
  );

  if (!wordsToSubmit.length) {
    return;
  }

  wordsToSubmit.forEach((word) => (word.submitted = true));

  const lastWordToSubmit = last(wordsToSubmit);
  if (lastWordToSubmit.text === '') {
    lastWordToSubmit.submitted = false;
    this.currentWordIndex = lastWordToSubmit.index;
  }

  // on créé un nouveau mot
  if (lastWordToSubmit.index === this.script.length - 1) {
    const newWord = {
      ...lastWordToSubmit,
      submitted: false,
      text: '',
      newline: true,
      startTime: lastWordToSubmit.endTime,
      letters: [],
      markWord: false,
      cpbefore: false,
      cpafter: false,
      cpinside: false,
    };

    this.script.push(newWord);

    this.onCanvasChange(true);
  }

  const nextWord = this.script[lastWordToSubmit.index + 1];
  if (nextWord) {
    this.currentWordIndex = nextWord.index;
    this.currentLineIndex = nextWord.indexLine;

    this.scrollToDown(nextWord, nextWord.indexLine - indexLine);
  }

  this.onChange(index, startTime);
}

// ***************************************************************************************
// onCancelSubmittedWords permet d'annuler tous les mots validés
// ***************************************************************************************
export function onCancelSubmittedWords() {
  this.script
    .filter((x) => x.submitted)
    .forEach((word) => (word.submitted = false));

  this.onChange(this.currentWord.index, this.currentWord.startTime);
}

// ***************************************************************************************
// onSelectLetterByLetter permet de sélectionner lettre par lettre
// ***************************************************************************************
let selectCurrentWordIndex = 0;
let selectCurrentLetterIndex = 0;
let selectCurrentDirection = '';
export function onSelectLetterByLetter(key) {
  if (!this.underSelection) {
    if (!this.currentWord.text) {
      return;
    }

    this.underSelection = true;
    this.wordsToSelect = [];
    this.lettersToSelect = [];

    selectCurrentWordIndex = this.currentWord.index;
    selectCurrentLetterIndex = this.currentLetter.index;
    selectCurrentDirection = key;

    if (key === 'SELECTLETTERBYLETTERONRIGHT') {
      this.lettersToSelect.push(this.currentLetter);
      return;
    }
  }

  if (selectCurrentWordIndex === 0 && selectCurrentLetterIndex === 0) {
    return;
  }

  if (selectCurrentDirection === key) {
    if (key === 'SELECTLETTERBYLETTERONLEFT') {
      if (selectCurrentLetterIndex === 0) {
        selectCurrentWordIndex -= 1;
        selectCurrentLetterIndex =
          this.script[selectCurrentWordIndex].letters.length - 1;
      } else {
        selectCurrentLetterIndex--;
      }
    } else {
      if (
        selectCurrentLetterIndex ===
        this.script[selectCurrentWordIndex].letters.length - 1
      ) {
        selectCurrentLetterIndex = 0;
        selectCurrentWordIndex += 1;
      } else {
        selectCurrentLetterIndex++;
      }
    }
  } else {
    // on change de direction
    selectCurrentDirection = key;
  }

  const letter =
    this.script[selectCurrentWordIndex].letters[selectCurrentLetterIndex];

  if (letter) {
    // Si la lettre est déjà sélectionnée, on la déselectionne
    const indexToRemove = this.lettersToSelect.findIndex(
      (l) =>
        l.index === letter.index &&
        l.indexWord === letter.indexWord &&
        l.indexLetter === letter.indexLetter
    );
    if (indexToRemove !== -1) {
      this.lettersToSelect.splice(indexToRemove, 1);
    } else {
      if (key === 'SELECTLETTERBYLETTERONLEFT') {
        this.lettersToSelect.unshift(letter);
      } else {
        this.lettersToSelect.push(letter);
      }
    }
  }

  this.currentWordIndex = selectCurrentWordIndex;
  this.currentLetterIndex = selectCurrentLetterIndex;

  this.onRefreshCanvas(false);
}
